<div class="billing-table-wrapper" [class.scrollable]="scrollable">
  <table>
    <caption>
      {{ caption }}
    </caption>

    @if (tableHeader) {
    <tr>
      <th>{{ 'BILLING.COLUMN_HEADERS.STATUS' | translate }}</th>
      <th>{{ 'BILLING.COLUMN_HEADERS.QUANTITY' | translate }}</th>
      <th class="price-column">{{ ('BILLING.COLUMN_HEADERS.UNIT_PRICE' | translate) + ', ' + clientCurrency?.code }}</th>
      <th>{{ ('BILLING.COLUMN_HEADERS.LINE_TOTAL' | translate) + ', ' + clientCurrency?.code }}</th>
    </tr>
    }

    <ng-content></ng-content>

    @if (notes) {
    <div class="notes">
      <ng-content select="[notes]"></ng-content>
    </div>
    }
  </table>
</div>
